import { getEnabledFeatureFlagsCookie } from '~/features/cookies/utils/get-enabled-feature-flag-cookie';
import { publicEnv } from '~/features/environment/public';
import { useUserPurchaseStats } from '~/features/user/hooks/use-user-purchase-stats';
import { useClientRender } from '~/hooks/use-client-render';

import { FREE_TRIAL_FEATURE_FLAG_KEY } from '../constants';

export function useFreeTrialEligibilityForAuthUser(): {
  eligible: boolean;
  isLoading: boolean;
  status: 'idle' | 'loading' | 'success' | 'error';
} {
  const clientReady = useClientRender();
  const isForceEnabled =
    publicEnv.NEXT_PUBLIC_ENVIRONMENT_NAME !== 'production' &&
    clientReady &&
    getEnabledFeatureFlagsCookie().includes(FREE_TRIAL_FEATURE_FLAG_KEY);

  const { eligibleForTrial: eligible, isLoading, status } = useUserPurchaseStats();

  if (isForceEnabled) {
    return { eligible: true, isLoading: false, status: 'success' };
  }

  return { eligible: eligible === true, isLoading, status };
}
